import { Outlet } from 'react-router-dom';
import { ObjectProvider } from 'modules/objects';

const ObjectWrapper = () => {
  return (
    <ObjectProvider>
      <Outlet />
    </ObjectProvider> 
  );
};

export default ObjectWrapper;